import theme from '../../theme'

export const dropdownContentStyles = {
  pt: '20px',
  background: 'var(--floating-element-background)',
  borderRadius: '3px',
  border: '1px solid',
  borderColor: 'var(--floating-element-border)',
  boxShadow: 'popover',
  '[cmdk-list]': {
    // 👇 We can potentially leverage the --radix-popover-content-available-height CSS variable here too
    maxHeight: '280px',
    minWidth: '300px',
    maxWidth: '350px',
    pb: '20px',
    overflow: 'auto',
    overscrollBehavior: 'contain',
    '&:focus, &:focus-visible': {
      // cmdk quirk: when used without a search input, we need to focus the list to enable keyboard navigation
      // in this instance we want to hide the focus outline from the listbox
      outline: 'none'
    }
  },
  '[cmdk-group]': {
    '&:not(:first-of-type)': {
      mt: '15px',
      pt: '15px',
      borderTop: '1px solid',
      borderColor: 'light-dark(var(--brand-grey-100), var(--brand-grey-500))'
    }
  },
  '[cmdk-group-heading]': {
    ...theme.text.paragraph.sm,
    color: 'light-dark(var(--brand-grey-400), var(--brand-grey-200))',
    fontWeight: 700,
    p: '0 20px 10px 20px'
  },
  '[cmdk-item]:not([data-value="load-more"])': {
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: '6px 20px',
    cursor: 'pointer',
    ':first-child': {
      flexGrow: 1
    },
    '[data-name="CheckIcon"]': {
      visibility: 'hidden'
    },
    '&[data-active="true"]': {
      color: 'light-dark(var(--brand-blue-300), var(--brand-grey-50))',
      '[data-name="CheckIcon"]': {
        visibility: 'visible'
      }
    },
    '&[data-selected="true"]': {
      color: 'white',
      backgroundColor: 'light-dark(var(--brand-blue-300), var(--brand-grey-400))',
      '[data-name="CheckIcon"]': {
        color: 'white'
      }
    },
    '&[data-variant="image"]': {
      '[data-name="image-label-wrap"]': {
        display: 'grid',
        gridTemplateColumns: 'max-content auto',
        alignItems: 'center',
        gap: '15px',
        img: {
          minWidth: '80px',
          height: 'auto'
        }
      }
    }
  },
  '[data-value="load-more"]': {
    p: '15px 20px',
    '[data-name="button-tertiary"]': {
      display: 'block'
    },
    '&[data-selected="true"]:not(&:hover) [data-name="button-tertiary"]': {
      outline: '2px solid',
      outlineColor: 'blue300'
    }
  }
}

export const selectSearchStyles = {
  position: 'relative',
  m: '0px 20px 15px 20px',
  '[data-name="SearchIcon"]': {
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  '[cmdk-input]': {
    ...theme.text.paragraph.sm,
    width: '100%',
    p: '10px 38px',
    backgroundColor: 'light-dark(white, var(--brand-grey-600))',
    borderRadius: '3px',
    border: '1px solid',
    borderColor: 'light-dark(var(--brand-grey-200), var(--brand-grey-400))',
    color: 'light-dark(var(--brand-grey-400), var(--brand-grey-200))',
    '&:focus, &:focus-visible': {
      outline: '2px solid',
      outlineColor: 'blue300',
      outlineOffset: '-1px'
    }
  },
  '[data-name="clear-search-button"]': {
    all: 'unset',
    position: 'absolute',
    display: 'flex',
    right: '6px',
    top: '50%',
    p: '6px',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    '&:hover': {
      color: 'blue300'
    },
    '&:focus, &:focus-visible': {
      outline: '2px solid',
      outlineColor: 'blue300'
    }
  }
}
